import { Select, SelectItem } from "@heroui/react";
import { i18n } from "@lingui/core";
import { t } from "@lingui/core/macro";
import { useField } from "remix-validated-form";
import { getFormErrorMessage } from "~/schema/translation";

export const getLanguages = () => [
  { code: "en", name: t`English` },
  { code: "fr", name: t`French` },
];

type FormProps = {
  formId: string;
  name: string;
  defaultValue?: string | null;
  variant?: "bordered" | "underlined";
  "data-testid"?: string;
};

export const FormLanguageSelector = ({
  formId,
  name,
  variant,
  defaultValue,
  "data-testid": dataTestId,
}: FormProps) => {
  const { error: languageError, getInputProps } = useField(name, {
    formId: formId,
  });

  const props = getInputProps();

  return (
    <Select
      name={name}
      label={t`Preferred language`}
      isInvalid={!!languageError}
      errorMessage={languageError ? getFormErrorMessage(languageError) : undefined}
      showScrollIndicators={false}
      disallowEmptySelection
      defaultSelectedKeys={defaultValue ? [defaultValue] : [i18n.locale]}
      variant={variant}
      items={getLanguages()}
      onBlur={props.onBlur}
      onChange={props.onChange}
      data-testid={dataTestId}
    >
      {(item) => (
        <SelectItem
          textValue={item.name}
          key={item.code}
        >
          {item.name}
        </SelectItem>
      )}
    </Select>
  );
};

type Props = {
  name: string;
  defaultValue?: string | null;
  onChange?: (value: string) => void;
  variant?: "bordered" | "underlined";
};

export const LanguageSelector = ({ name, variant, defaultValue, onChange }: Props) => {
  return (
    <Select
      labelPlacement="outside"
      name={name}
      label={t`Preferred language`}
      showScrollIndicators={false}
      disallowEmptySelection
      defaultSelectedKeys={defaultValue ? [defaultValue] : [i18n.locale]}
      variant={variant}
      onChange={(e) => {
        onChange?.(e.target.value);
      }}
    >
      {getLanguages().map((item) => (
        <SelectItem
          textValue={item.name}
          key={item.code}
        >
          {item.name}
        </SelectItem>
      ))}
    </Select>
  );
};
